import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { useEffect, useState } from "react";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { LinearProgress } from "@mui/material";
import { FormEditReseller } from "./FormEditReseller";
import {useParams} from "react-router";

export const PanelEditReseller = () => {
  const {id} = useParams()
  console.log(id)
  const [reseller, setReseller] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const getReseller = async () => {
      setIsLoading(true);
      const { response, message } = await Helper.Get({
        url: id ? `${api_Routes.Resellers.GetOne}/${id}`:api_Routes.Resellers.GetOneByAdmin,
        hasToken: true,
      });
      if (response) {
        setReseller(response.data);
      }
      setIsLoading(false);
    };
    getReseller();
  }, []);
  if (isLoading) {
    return <LinearProgress />;
  }
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Edit Reseller Page</div>
          </div>
        }
      />
      <PanelBody content={<FormEditReseller reseller={reseller} />} />
    </div>
  );
};
